import styled from 'styled-components';
import { background, border, color, compose, flexbox, grid, layout, position, shadow, space, system, typography, } from 'styled-system';
// TODO: Move other "system" to another package?
const boxSizing = system({
    boxSizing: {
        property: 'boxSizing',
    },
});
const styleProps = compose(background, border, boxSizing, color, flexbox, grid, layout, position, shadow, space, typography);
export const Divider = styled.hr.attrs(({ bg = 'lightGrey', border = 'none', boxSizing = 'border-box', height = '1px', }) => ({
    bg,
    border,
    boxSizing,
    height,
}))(styleProps);
